import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { CredentialStorage } from "./credentials-storage";
import { Injectable } from "@angular/core";

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
    constructor(
        private credentialStorage: CredentialStorage
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const credentials = this.credentialStorage.current();
        const newRequest = req.clone({
            setHeaders: {
                Authorization: credentials?.authHeader ?? ''
            }
        });

        return next.handle(newRequest);
    }
}